// ===== Interfaces =====

import {
    IResolveCustomCursorActiveArgs,
}                                           from '../interfaces/IResolveCustomCursorActiveArgs';

/**
 * Resolves whether the custom cursor should render after hard device/performance
 * overrides and the user's saved preference are all considered.
 */
const resolveCustomCursorActive = ({
    customCursorEnabled,
    isMobileDevice,
    performanceGateOff,
}: IResolveCustomCursorActiveArgs): boolean => {
    if (performanceGateOff) return false;
    if (isMobileDevice) return false;

    return customCursorEnabled !== false;
};

export default resolveCustomCursorActive;
